<template>
	<div>
		<div class="wwei-home-index-h-warp">
			<div class="wwei-home-index-warp">
				<div class="wwei-home-index-warp-com wwei-home-index-warp-left"
					:class="codeType<1?'':'wwei-home-index-warp-left-live-code'">
					<staticcode v-if="codeType==0" @qsetrcodeImgBase64="setqrcodeImgBase64" @changeContent="changeContent"></staticcode>
					<videoMod ref="videomod" @gettitle="gettitle" :qrImg="qrImg" :setData="setData" :listData="pagedata.content_html" :dataChanged="dataChanged" v-if="codeType==1"></videoMod>
					<audioMod ref="audiomod"  @gettitle="gettitle" :qrImg="qrImg" :setData="setData" :listData="pagedata.content_html" :dataChanged="dataChanged" v-if="codeType==2"></audioMod>
					<imgMod ref="imagemod" @gettitle="gettitle" :qrImg="qrImg" :setData="setData" :listData="pagedata.content_html" :dataChanged="dataChanged" :img_prese="pagedata.content_html.img_prese" :img_style="pagedata.content_html.img_style" v-if="codeType==3"></imgMod>
					<fileMod ref="filemod" @gettitle="gettitle" :qrImg="qrImg" :setData="setData" :listData="pagedata.content_html" :dataChanged="dataChanged" v-if="codeType==4"></fileMod>
				</div>
				<div class="wwei-home-index-warp-com wwei-home-index-warp-right"
					:class="codeType<1?'':'wwei-home-index-warp-right-live-code'">
					<setMod ref="setmod" :id_key="id_key" :title="title" @setImgsetdata="setImgsetdata" @setqrImg="setqrImg" :pagedata="pagedata" :setData="setData" :qrcodeContent="qrcodeContent" :codeType="codeType"></setMod>
				</div>
				<div class="wwei-home-index-warp-bottom">
					<div class="indexItems" :class="codeType==0 && initCodeType?'on':''" @click="setCodetype(0)">
						<div>
							<img src="/wwcn/image/icon/text.png">
							<p>静态码</p>
						</div>
					</div>
					<div class="indexItems"  @click="setCodetype(9)">
						<div>
							<img src="/wwcn/image/icon/form.png">
							<p>图文混编</p>
						</div>
					</div>
					<div class="indexItems" :class="codeType==1?'on':''" @click="setCodetype(1)">
						<div>
							<img src="/wwcn/image/icon/video.png">
							<p>视频活码</p>
						</div>
					</div>
					<div class="indexItems" :class="codeType==2?'on':''"  @click="setCodetype(2)">
						<div>
							<img src="/wwcn/image/icon/audio.png">
							<p>音频活码</p>
						</div>
					</div>
					<div class="indexItems" :class="codeType==3?'on':''" @click="setCodetype(3)">
						<div>
							<img src="/wwcn/image/icon/img.png">
							<p>图片活码</p>
						</div>
					</div>
					<div class="indexItems" :class="codeType==4?'on':''"  @click="setCodetype(4)">
						<div>
							<img src="/wwcn/image/icon/file.png">
							<p>文件活码</p>
						</div>
					</div>
					<div class="indexItems"  @click="setCodetype(5)">
						<div>
							<img src="/wwcn/image/icon/card.png">
							<p>名片活码</p>
						</div>
					</div>
					<div class="indexItems"  @click="setCodetype(6)">
						<div>
							<img src="/wwcn/image/icon/map.png">
							<p>导航活码</p>
						</div>
					</div>
					<div class="indexItems"  @click="setCodetype(7)">
						<div>
							<img src="/wwcn/image/icon/wifi.png">
							<p>wifi活码</p>
						</div>
					</div>
					<div class="indexItems"  @click="setCodetype(8)">
						<div>
							<img src="/wwcn/image/icon/url.png">
							<p>网址活码</p>
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
		
		<a-modal :confirm-loading="confirmLoading" :destroyOnClose="true"  cancelText="取消" okText="确认" :centered="true" :visible="visible" @ok="handleOk" @cancel="handleCancle" title="选择文件" width="92%" wrapClassName="full-modal">
			<div style="width: 100%; height: calc(100vh - 248px);">
				<attach_manage :isPageOrModel="isPageOrModel" :modalType="modalType" :multiple="multiple"
					@getlistsfromLib="getlistsfromLib">
				</attach_manage>
			</div>	
		</a-modal>
		<lists></lists>
	<!-- 	<a-modal width="1280" :mask="true" :destroyOnClose="true" :footer="null"  cancelText="取消" okText="确认" :centered="true" :visible="beautifyVisible" @ok="beautifyOk" @cancel="beautifyCancle" title="二维码美化">
			<beautifyMod></beautifyMod>
		</a-modal> -->
	</div>
	<!-- <button @click="openbeautify">美化</button> -->
</template>

<script>
	import {
		message
	} from 'ant-design-vue';
	import attach_manage from '../attach_manage/App.vue';
	
	import beautifyMod from '../../components/beautifyMod';
	import staticcode from '../../components/home/staticcode';
	import videoMod from '../../components/videoMod';
	import audioMod from '../../components/audioMod';
	import setMod from '../../components/setMod';
	import imgMod from '../../components/imgMod';
	import fileMod from '../../components/fileMod';
	import lists from '../../components/lists';
	import caseView from '../../components/caseView';
	export default {
		name: 'Home',
		components: {
			staticcode,
			videoMod,
			setMod,
			attach_manage,
			audioMod,
			imgMod,
			fileMod,
			lists,
			caseView,beautifyMod
		},
		props: {},
		data() {
			return {
				beautifyVisible:false,//美化
				initCodeType:false,/*是否已经初始化*/
				caseviewshow:false,
				title:'',
				visible:false,
				multiple:1,
				modalType:1,
				isPageOrModel:2,
				id_key:'',
				qrImg:'',//二维码图片
				codeType: 0, //1视频，2音频，3图片，4文件
				dataChanged:{
					dataChanged:false
				},
				qrcodeContent:{
					qrcode_type:"text",/*二维码类型*/
					topCurrent:1,/*1：静态文本*/
					content:this.freeText,/*二维码内容*/
				},/*二维码内容*/
				setData: {
					openType: 1, //1默认2无标识3h5
					styleType: 1, //1默认2集合3刷一刷
				},
				pagedata: {
					name: "file",/*类型 文件：file 图片：image 视频：video 音频：audio*/
					component_code: "file",/*类型 文件：file 图片：image 视频：video 音频：audio*/
					sort: 0,
					content_html: {
						types: "file",/*类型 文件：file 图片：image 视频：video 音频：audio*/
						auto_increment: 1,//(lists.length)
						img_prese: 1,/*图片展示设置 1：平铺 2：轮播 5：轮播切片*/
						img_style: 1,/*图片样式设置 1：留白 2：撑满 3：置顶撑满*/
						lists: []
					},
				},
				chooseData:[],//附件库选择的文件临时存储
				file_keys:'',
				confirmLoading:false,
			}
		},
		watch: {
			
			setData: {
				deep: true,
				handler(newval,oldval) {
					this.dataChanged.dataChanged=true;
				}
			},
			pagedata:{
				deep: true,
				handler(newval,oldval) {
					// console.log(newval)
					this.dataChanged.dataChanged=true;
				}
			}
		},
		created() {

		},
		beforeDestroy() {},
		methods: {
			downloadOrtherExtFunc(){
				this.$refs.setmod.downloadOrtherExtData.openDownloadOrtherExt()
			},
			beautifyCancle(){
				this.beautifyVisible=false;
			},
			openbeautify(){
				this.beautifyVisible=true;
			},
			openset(){
				this.$refs.setmod.openQrcodeSet();
			},
			setImgsetdata(e){
				this.pagedata=e
			},
			setIdkey(e){
				this.id_key=e;
			},
			gettitle(e){
				this.title=e;
			},	
			getlistsfromLib(e){
				var file_keys=[];
				for(let i=0;i<e.length;i++){
					file_keys.push(e[i].file_key)
				}
				this.file_keys=file_keys.join(',');
			},
			handleOk(){
				this.confirmLoading=true;
				var array=[];
				this.$apiRequest.post('/qrcode/create/getAttachFilekeys',{
					file_keys:this.file_keys
				}).then(res=>{
					if(res.data.code==200){
						for(let i=0;i<res.data.data.length;i++){
							res.data.data[i]['upload_hanlde']={
								progress:101,
							}
							res.data.data[i]['exchanging']={
								progress:101,
								exchanging:false,
								time:0
							}
							res.data.data[i]['listIndex']=i+this.pagedata.content_html.lists.length;
							
							// file_type==2音频1视频
							// codeType=1视频，2音频，3图片，4文件,5导航，6wifi，7表单，8，9网址
							switch (this.codeType){
								case 1:
								if(res.data.data[i].type=='video'){
									array.push(res.data.data[i])
								}
								break;
								case 2:
								if(res.data.data[i].type=='audio'){
									array.push(res.data.data[i])
								}
								break;
								default:
									array.push(res.data.data[i])
							}
						}
						this.visible=false;
						this.pagedata.content_html.lists=this.pagedata.content_html.lists.concat(array)
					}
					this.confirmLoading=false;
				}).catch(err=>{
					this.confirmLoading=false;
				})
				this.pagedata.content_html.lists=this.pagedata.content_html.lists.concat(this.chooseData)
			},
			handleCancle(){
				this.visible=false;
				this.chooseData=[];
			},
			showfileMod(){
				this.visible=true;
			},
			setqrImg(e){
				this.qrImg=e;
			},
			setCodetype(e) {
				// codeType=1视频，2音频，3图片，4文件,5：名片，6导航，7wifi，8网址， 9表单
				//modalType=1图片2音视频3文件
				if(e==1||e==2){
					this.modalType=2;
				}else if(e==3){
					this.modalType=1
					var data={
						name: "image",/*类型 文件：file 图片：image 视频：video 音频：audio*/
						component_code: "image",/*类型 文件：file 图片：image 视频：video 音频：audio*/
						sort: 0,
						content_html:{
							types: "image",/*类型 文件：file 图片：image 视频：video 音频：audio*/
							auto_increment: 0,//(lists.length)
							img_prese: 1,/*图片展示设置 1：平铺 2：轮播 3：轮播切片*/
							img_style: 1,/*图片样式设置 1：留白 2：撑满 3：置顶撑满*/
							lists: []
						}
					}
					this.setImgsetdata(data)//清空图片设置默认值
				}else if(e==4){
					this.modalType=3
				}else if(e==5){//名片
					window.open("https://www.wwei.cn/qrcode-index-vcard.html");
					return false;
				}else if(e==6){//导航
					window.open("https://www.wwei.cn/qrcode-index-map.html");
					return false;
				}else if(e==7){//wifi
					window.open("https://www.wwei.cn/qrcode-index-wifis.html");
					return false;
				}else if(e==8){//网址
					window.open("https://www.wwei.cn/url");
					return false;
				}else if(e==9){//高级编辑器
					window.open("https://bianji.wwei.cn/gedit");
					return false;
				}
				this.initCodeType = true;
				this.codeType = e;
				// 这一步清空二维码
				var data={
					qrcode_type: "video",//video audio file image
					topCurrent: 2,
					content: '',//xx.com
					id_key:"",
					create_init:1,/*1：当前新增 2：当前修改*/
				}
				this.changeContent(data)
				//清空列表
				this.pagedata.content_html.lists=[];
				this.id_key='';
				if(e==1){
					this.$nextTick(function(){
						this.$refs.videomod.setgeneratedfalse()
						this.$refs.videomod.clearidkey();
					})
				}else if(e==2){
					this.$nextTick(function(){
						this.$refs.audiomod.setgeneratedfalse()
						this.$refs.audiomod.clearidkey()
					})
				}else if(e==3){
					this.$nextTick(function(){
						this.$refs.imagemod.setgeneratedfalse()
						this.$refs.imagemod.clearidkey()
					})
				}else if(e==4){
					this.$nextTick(function(){
						this.$refs.filemod.setgeneratedfalse()
						this.$refs.filemod.clearidkey()
					})
				}
				
			},
			changeContent(e){
				// this.$emit("changeContent", {
				// 	qrcode_type: "content",//video audio file image
				// 	topCurrent: 2,
				// 	content: this.websiteText,//xx.com
				// 	id_key:"",
				// 	create_init:1,/*1：当前新增 2：当前修改*/
				// });
				if(typeof e.topCurrent !="undefined" && parseInt(e.topCurrent)==2 && e.content && e.qrcode_type=="text"){
					var url = e.content;
					if(url.indexOf("http://") < 0&&url.indexOf("https://") < 0&&url.indexOf("ftp://") < 0&&url.indexOf("rtsp://") < 0&&url.indexOf("mms://") < 0){
					    url='http://'+url;
					}
					e.content = url;
				}
				this.qrcodeContent = e;
				
			},
			setqrcodeImgBase64(e){
				this.qrcodeImgBase64=e;
			}
		},
	}
</script>

<style>
	.beautifyModal .ant-modal{width: 1280px !important;}
	@media (max-width: 1282px){.beautifyModal .ant-modal{width: 1100px !important;}}
	@media (max-width: 1110px){.beautifyModal .ant-modal{width: 1000px !important;}}
	
	.beautifyModal .ant-modal-body{padding: 0 !important;}
	
	.mbm_move_model_center_footer .ant-btn-primary:hover, .ant-btn-primary:focus{
		background: #09bd71 !important;
		border-color: #09bd71 !important;
	}
	.indexItems img {
		width: 45px;
		height: 45px;
		margin: 0 auto;
		display: block;
	}
	.indexItems p {
		width: 100%;
		font-size: 16px;
		text-align: center;
		margin: 20px auto 0;
		padding: 0;
		/* font-weight: 600; */
	}

	.indexItems {
		font-size: 0;
		width: 105px;
		height: 130px;
		background-color: #fff;
		box-shadow: 0 0px 6px rgba(0, 0, 0, .1);
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		font-weight: 600;
		flex-wrap: wrap;
		border: 1px solid rgba(0, 0, 0, 0);
		transition: all 0.2s;
		color: #262e48;
	}
	.indexItems:hover,.indexItems.on{
		border-color: #09bd71;
		color: #09bd71;
	}
	.wwei-home-index-warp-bottom {
		width: 100%;
		margin-top: 52px;
		display: flex;
		justify-content: space-between;
	}
	.wwei-home-index-h-warp{
		width: 100%;
		position: relative;
		margin: 0;
		padding: 47px 0 52px;
		background-color: #ecf3fc;
		background-image: linear-gradient(#ecf3fc,#fff);
	}
	.wwei-home-index-warp {
		width: 1200px;
		margin: 0 auto;
		padding: 0;
		position: relative;
		font-size: 14px;
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.wwei-home-index-warp .wwei-home-index-warp-com {
		background-color: #ffffff;
		border-radius: 8px;
		box-shadow: 0 10px 20px #eaeff3c9;
		min-height: 300px;
		transition: width 0.2s;
	}

	.wwei-home-index-warp .wwei-home-index-warp-left {
		width: 840px;
		min-height: 467px;
	}

	.wwei-home-index-warp .wwei-home-index-warp-right {
		width: 335px;
		min-height: 460px;
	}
	
	.wwei-home-index-warp .wwei-home-index-warp-left-live-code {
		width: 710px;
		min-height: 540px;
	}

	.wwei-home-index-warp .wwei-home-index-warp-right-live-code {
		width: 465px;
		height: 570px;
	}
</style>
